// Client mirror of the date tokens in functions/_shared/template-renderer.js,
// so the live preview shows the same words the sent email will. Keep the two
// in step: New York time, NYC school year (July onwards = the coming year).

export const RENDER_TIME_ZONE = 'America/New_York';
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function nyParts(date) {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: RENDER_TIME_ZONE, year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(date);
  const get = (t) => Number(parts.find((p) => p.type === t)?.value);
  return { year: get('year'), month: get('month'), day: get('day') };
}

export function schoolYearLabel(year, month) {
  const start = month >= 7 ? year : year - 1;
  return `${start}–${String((start + 1) % 100).padStart(2, '0')}`;
}

export function buildDateTokens(now = new Date()) {
  const d = now instanceof Date ? now : new Date(now);
  if (Number.isNaN(d.valueOf())) return buildDateTokens(new Date());
  const { year, month, day } = nyParts(d);
  return {
    today: `${MONTHS[month - 1]} ${day}, ${year}`,
    current_month: MONTHS[month - 1],
    next_month: MONTHS[month % 12],
    current_year: String(year),
    next_year: String(year + 1),
    school_year: schoolYearLabel(year, month),
    next_school_year: schoolYearLabel(year + 1, month),
  };
}

export const DATE_TOKEN_NAMES = Object.keys(buildDateTokens(new Date('2026-09-25T12:00:00Z')));
